import React, { useState, useRef } from 'react';
import { filesService } from '../../services/files';
import { usersService } from '../../services/users';
import './PersonalData.css';

const PersonalData = ({ user, onBack }) => {
  const [avatarUrl, setAvatarUrl] = useState(user?.avatarUrl || '');
  const [firstName, setFirstName] = useState(user?.firstName || '');
  const [lastName, setLastName] = useState(user?.lastName || '');
  const [isUploading, setIsUploading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const fileInputRef = useRef(null);

  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setIsUploading(true);
    try {
      const result = await filesService.uploadFile(file, 'avatars');
      setAvatarUrl(result.url);
      
      await usersService.updateUser(user.id, { avatarUrl: result.url });
    } catch (error) {
      console.error('Ошибка загрузки аватара:', error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleUpdateUser = async () => {
    if (!firstName.trim() || !lastName.trim()) {
      alert('Имя и фамилия не могут быть пустыми');
      return;
    }
    
    setIsSaving(true);
    try {
      await usersService.updateUser(user.id, {
        firstName: firstName.trim(),
        lastName: lastName.trim()
      });
      alert('✅ Данные успешно обновлены!');
    } catch (error) {
      console.error('Ошибка обновления:', error);
      alert('❌ Ошибка при обновлении данных');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="personal-data-container">
      <div className="personal-data-header">
        <button className="back-btn" onClick={onBack}>← Назад</button>
        <h2>Личные данные</h2>
      </div>
      
      <div className="personal-data-body">
        <div className="personal-data-layout">
          {/* Левая колонка - аватар */}
          <div className="avatar-column">
            <div className="avatar-section">
              <div className="avatar-preview">
                {avatarUrl ? (
                  <img src={avatarUrl} alt="Аватар" className="avatar-img" />
                ) : (
                  <div className="avatar-placeholder">
                    {user?.username?.[0]?.toUpperCase() || '?'}
                  </div>
                )}
              </div>
              <button 
                className="upload-btn" 
                onClick={() => fileInputRef.current?.click()}
                disabled={isUploading}
              >
                {isUploading ? 'Загрузка...' : '📷 Загрузить фото'}
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleAvatarUpload}
                accept="image/*"
                style={{ display: 'none' }}
              />
            </div>
          </div>
          
          {/* Правая колонка - информация */}
          <div className="info-column">
            <div className="info-section">
              <h3>📝 Редактирование профиля</h3>
              <div className="form-group">
                <label>Имя</label>
                <input 
                  type="text" 
                  value={firstName} 
                  onChange={e => setFirstName(e.target.value)}
                  className="settings-input"
                  placeholder="Введите ваше имя"
                />
              </div>
              <div className="form-group">
                <label>Фамилия</label>
                <input 
                  type="text" 
                  value={lastName} 
                  onChange={e => setLastName(e.target.value)}
                  className="settings-input"
                  placeholder="Введите вашу фамилию"
                />
              </div>
              <button 
                className="save-btn" 
                onClick={handleUpdateUser}
                disabled={isSaving || isUploading}
              >
                {isSaving ? 'Сохранение...' : '💾 Сохранить изменения'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalData;